import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { setColor } from '../icon.utilities';
export function SAIconChevronRightBold(_a) {
    var colorVariant = _a.colorVariant, size = _a.size;
    var theme = useContext(ThemeContext);
    var color = setColor(theme, colorVariant, 'secondary');
    var renderSize = size !== null && size !== void 0 ? size : '100px';
    return (React.createElement("svg", { width: renderSize, height: renderSize, viewBox: "0 0 100 100", version: "1.1", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" },
        React.createElement("path", { d: "M25 77.7778L38.8889 91.6667L80.5556 50L38.8889 8.33335L25 22.2222L52.7778 50L25 77.7778Z", fill: color })));
}
//# sourceMappingURL=icon.chevron-right-bold.component.js.map